import card1 from "../assets/airfry.jpg";
import card2 from "../assets/convection.jpg";
import card3 from "../assets/micro.jpg";
import card4 from "../assets/mixer.jpg";

const products = [
  {
    name: "airfryer",
    image: card1,
    link: "https://www.amazon.in/dp/B09VDPYKSC/ref=cm_sw_r_as_gl_api_gl_i_1JQVCY84BMYDZJF56J2A?linkCode=ml2&tag=youtube04d77-21",
  },
  {
    name: "convection oven",
    image: card2,
    link: "https://www.amazon.in/dp/B07MHDZ4W3/ref=cm_sw_r_as_gl_api_gl_i_WJ6HQX2D1VYTNP65CM6M?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "microwave",
    image: card3,
    link: "https://www.amazon.in/dp/B07M8GJKH2/ref=cm_sw_r_as_gl_api_gl_i_VR9E32QTGN2WSHN9EN99?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "mixer grinder",
    image: card4,
    link: "https://www.amazon.in/dp/B010LE4R94/ref=cm_sw_r_as_gl_api_gl_i_ZAX6A54K1T5P18NK02PK?linkCode=ml1&tag=youtube04d77-21&th=1",
  },
];

const ShopMyFavourites = () => {
  return (
    <section className="py-24 bg-[#fff9e6]">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <h2 className="text-center text-4xl md:text-5xl font-serif text-[#c17b8c] mb-16">
          Shop My Favourites
        </h2>

        {/* Product Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-[#a85b73] rounded-3xl p-6 flex flex-col items-center"
            >
              {/* Image */}
              <div className="bg-white rounded-2xl p-6 w-full h-56 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="max-h-full object-contain"
                />
              </div>

              {/* Name */}
              <h3 className="mt-6 mb-4 text-white font-serif text-xl capitalize">
                {product.name}
              </h3>

              {/* Button */}
              <a
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto bg-[#e6c04c] text-[#5a5a00] px-6 py-2 rounded-full text-sm font-medium hover:bg-[#d8b43f] transition"
              >
                View Product
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ShopMyFavourites;
